import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=fe7b35b2&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=fe7b35b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe7b35b2"

export default script